import { SerializedComponent } from "../../components/SerializedApp";
import { panic } from "../../Support";
import { makeTextWithTypeKind } from "../builder-utils";
import { ComponentBuilder, ComponentConfiguratorContext } from "../components";
import {
    ActionDescription,
    ActionKind,
    InputOutputTables,
    PropertyDescription,
    isLinkTypeKind,
    MutatingScreenKind,
} from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { DescriptionToken } from "./action-handler";
import { BaseActionHandler, tokenForProperty } from "./base";
import { makeDataPropertyDescriptor } from "./copy-to-clipboard";

interface ShowShareScreenActionDescription extends ActionDescription {
    data?: PropertyDescription;
}

export class ShowShareScreenWithArgsHandler extends BaseActionHandler<ShowShareScreenActionDescription> {
    public readonly kind = ActionKind.ShowShareSheetWithArgs;

    public readonly iconName = "share";

    public getDescriptor(
        _desc: ShowShareScreenActionDescription | undefined,
        _tables: InputOutputTables | undefined,
        _ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ActionDescriptor {
        return {
            name: "Share Link",
            needsScreenContext: true,
            properties: [makeDataPropertyDescriptor("Enter URL or text", mutatingScreenKind)],
        };
    }

    public makeAction(
        builder: ComponentBuilder,
        desc: ShowShareScreenActionDescription,
        tables: InputOutputTables,
        screenContext: SerializedComponent | undefined
    ): SerializedComponent | undefined {
        const { b } = builder;
        if (screenContext === undefined) {
            return panic("Must have screen context for Show sharing options action");
        }

        const copyValue = makeTextWithTypeKind(
            builder,
            desc.data,
            tables.input,
            true,
            true,
            true,
            false,
            screenContext
        );
        if (copyValue === undefined) return undefined;

        const value = copyValue.text;
        const isURL = copyValue.typeKind !== undefined && isLinkTypeKind(copyValue.typeKind);

        return b.actionIfContextDefined(b.showShareSheet(isURL ? value : undefined, isURL ? undefined : value));
    }

    public getTokenizedDescription(
        desc: ShowShareScreenActionDescription,
        tables: InputOutputTables,
        ccc: ComponentConfiguratorContext
    ): readonly DescriptionToken[] | undefined {
        const columnToken = tokenForProperty(desc.data, tables, ccc);
        if (columnToken === undefined) return undefined;

        return [
            {
                kind: "string",
                value: "with data from ",
            },
            columnToken,
        ];
    }
}
